<template>
    <div>
        <v-row>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="4">
                <data-view
                    v-if="customer('is_company')"
                    :title="customer('company_name') || customer('email')"
                    :subtitle="$t('steps.summary.company')"
                    icon="mdi-account-tie"
                    :items="customerData">
                </data-view>
                <data-view
                    v-else
                    :title="fullName || customer('email')"
                    :subtitle="$t('steps.summary.private')"
                    icon="mdi-account"
                    :items="customerData">
                </data-view>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="8"
                lg="6">
                <data-view
                    :title="$t('steps.summary.order')"
                    :subtitle="$t('steps.summary.orderDescription')"
                    icon="mdi-shopping"
                    :items="orderData">
                </data-view>
            </v-col>
        </v-row>

        <div class="text-center">
            <v-btn class="mx-2" color="primary" @click="$emit('save')">
                {{ $t('base.save') }}
            </v-btn>
            <v-btn text @click="$emit('abort')">
                {{ $t('base.back') }}
            </v-btn>
        </div>

    </div>
</template>

<script>
    import DataView from '@/components/data/DataView'

    export default {
        components: {'data-view': DataView},
        computed: {
            configurator() {
                return this.$store.state.configurator
            },
            currencySymbol() {
                return this.configurator.currency.symbol ? this.configurator.currency.symbol : this.$store.state.configurator.defaultCurrency.symbol
            },
            customer() {
                return param => this.$store.getters.customer(param) || ''
            },
            customerData() {
                let data = [
                    {
                        label: this.$t('steps.customer.email'),
                        value: this.customer('email')
                    },
                    {
                        label: this.$t('steps.customer.phone'),
                        value: this.customer('phone')
                    },
                    {
                        label: this.$t('steps.customer.street'),
                        value: this.customer('street') + " " + this.customer('house') + (this.customer('apartment').trim() ? "/" + this.customer('apartment') : '')
                    },
                    {
                        label: this.$t('steps.customer.city'),
                        value: this.customer('postal').trim() ? this.customer('postal') + ", " + this.customer('city') : this.customer('city')
                    }
                ]
                if (this.customer('is_company')) {
                    data.unshift({
                        label: this.$t('steps.customer.nip'),
                        value: this.customer('nip')
                    })
                }
                return data
            },
            orderData() {
                let net = 0
                let gross = 0
                let items = this.configurator.offer.items.map(item => {
                    net += item.total
                    gross += item.total * (1 + item.tax/100)
                    return {
                        label: item.product[this.$locale] + ", ilość - " + item.amount,
                        value: this.$t('steps.offer.prices.total.net') + ": " + this.filterPrice(item.total) + this.currencySymbol,
                    }
                })
                items.push({
                    label: this.$t('steps.offer.summary'),
                    value: this.$t('steps.offer.prices.summary', {net: this.filterPrice(net), gross: this.filterPrice(gross), currency: this.configurator.currency.symbol}),
                    accent: true
                })
                return items
            },
            fullName() {
                return (this.customer('first_name') + " " + this.customer('last_name')).trim()
            }
        },
        methods: {
            filterPrice(price) {
                return this.$options.filters.trailingZeros(this.$options.filters.priceDecimal(price))
            }
        }
    }
</script>

<style scoped>
</style>
